import { styled } from "@mui/material";
export const MessageContainer = styled("div")`
    background-color: #111;
    padding: 0;
    font-size: 14px;
    text-align: center;
    line-height: 32px;
`;
